import { render } from "./TextOverlaysTab.vue?vue&type=template&id=5964d955"
import script from "./TextOverlaysTab.vue?vue&type=script&lang=js"
export * from "./TextOverlaysTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__